import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment';
import { BaseChartDirective } from 'ng2-charts';
import { UrlDetails } from 'src/app/url-shorterner/interfaces/IUrlDetails';
import { UrlShortenerCollectionService } from 'src/app/url-shorterner/services/url-shortener-collection.service';
import { IFollower } from '../../interfaces/IFollower';
import { TelegramCollectionService } from '../../services/telegram-collection.service';
import { INotification } from '../../interfaces/INotification';
import { MatPaginator } from '@angular/material/paginator';
import { GenerateNotificationDateList, GetMonthsInRange, GetWeeksInRange } from '../../helpers/notification/notificationUtils';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateFormat } from 'src/app/shared/helpers/DateFormat';
import { filter } from 'rxjs';

interface Period {
  value: string;
  viewValue: string;
}

export enum ToggleEnumRange {
  Daily,
  Weekly,
  Monthly
}

export interface NotificationsData {
  addedDate: string;
  totalFollowers: number;
  muted: number;
  unmuted: number;
  net: number;
}

@Component({
  selector: 'app-notification-index',
  templateUrl: './notification-index.component.html',
  styleUrls: ['./notification-index.component.scss'],
  providers: [   
    {provide: MAT_DATE_FORMATS, useValue: DateFormat},
  ],
})
export class NotificationIndexComponent implements OnInit {

  displayedColumns: string[] = ['addedDate', 'totalFollowers', 'muted', 'unmuted', 'net'];
  dataSource : MatTableDataSource<NotificationsData>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  @ViewChild(MatSort) sort: MatSort;

  generatingChart = false;
  periodLabel = [];
  periodTotalMuted = [];
  periodTotalUnmuted = [];
  urlInfo: any;
  returnFilter: any;
  maxValue = 10;

  periods: Period[] = [
    { value: 'TODAY', viewValue: 'Today' },
    { value: 'WEEK', viewValue: 'Past 7 Days' },
    { value: 'MONTH', viewValue: 'Past 30 Days' },
    { value: 'QUARTER', viewValue: 'Past 3 Months' },
    { value: 'LIFETIME', viewValue: 'Lifetime' },
  ];
  toggleEnumRange = ToggleEnumRange;
  selectedRange = ToggleEnumRange.Daily;
  selected = 'QUARTER';

  rangeFrom = new FormGroup({
    startFrom: new FormControl<Date | null>(null),
    endFrom: new FormControl<Date | null>(null),
  })

  rangeTo = new FormGroup({
    startTo: new FormControl<Date | null>(null),
    endTo: new FormControl<Date | null>(null),
  })

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    labels: this.periodLabel,
    datasets: [
      {
        data: [],
        label: 'Muted',
      },
      {
        data: [],
        label: 'Unmuted',
      },
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    scales: {
      y: {
        min: 0,
        max: this.maxValue
      },
    },
    elements: {
      line: {
        tension: 0 // disables bezier curves
      }
    }

  };

  public lineChartLegend = true;

  totalMutedRange: number = 0;
  totalMutedDateRange: string[] = [];

  totalUnmutedRange: number = 0;
  totalUnmutedDateRange: string[] = [];

  comparisonFrom: any;
  comparisonTo: any;

  mutedComparisonPercentage:any;
  unmutedComparisonPercentage:any;
  netComparisonPercentage:any;

  totalMutedFromRange: number = 0;
  totalMutedFromDateRange: string[] = [];

  totalUnmutedFromRange: number = 0;
  totalUnmutedFromDateRange: string[] = [];

  totalMutedToRange: number = 0;
  totalMutedToDateRange: string[] = [];

  totalUnmutedToRange: number = 0;
  totalUnmutedToDateRange: string[] = [];

  tableSourceOfMutedNWorst: any[] = [];

  rangeStart: string = '';
  rangeEnd: string = '';

  range: any;

  rangeStartFrom: string = '';
  rangeEndFrom: string = '';

  rangeStartTo: string = '';
  rangeEndTo: string = '';

  highestMuted = -Infinity;
  highestUnmuted = -Infinity;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly telegramCollectionService: TelegramCollectionService,
    private readonly router: Router,
    private activatedRoute: ActivatedRoute,
  ) {

    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.start !== undefined){
      this.rangeStart = this.activatedRoute.snapshot.queryParams.start.trim();
    } 
    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.end !== undefined){
      this.rangeEnd = this.activatedRoute.snapshot.queryParams.end.trim();
    }

    router.events.pipe(
      filter(event => event instanceof NavigationEnd)  
    ).subscribe((event) => {

      if((event as NavigationEnd).url === '/telegram/notification'){
        let endDate: any;
        let daysAgo: any;
    
        endDate = moment().format('MMM DD YYYY')
        daysAgo = moment().subtract(5, 'days').toDate();
    
        endDate = moment(endDate).format('MMM DD YYYY')
    
        let startDate: any = moment(daysAgo).format('MMM DD YYYY');
    
        this.rangeStart = startDate;
        this.rangeEnd = endDate;
        this.router.navigate(['/telegram/notification'],{queryParams:{start:moment(this.rangeStart).format('DD-MMM-YYYY'), end:moment(this.rangeEnd).format('DD-MMM-YYYY')}});
      }
    });


  }

  ngAfterViewInit() {
  }
  
  ngOnInit(): void {

    const element =  document.getElementById("chart");
    element.scrollIntoView()


    this.range = new FormGroup({
      startRange: new FormControl<Date | null>(new Date(this.rangeStart)),
      endRange: new FormControl<Date | null>(new Date(this.rangeEnd)),
    })


    this.loadNotifications(this.rangeStart, this.rangeEnd);
  }

  onFetchData() {
    if(this.range.value.startRange && this.range.value.endRange){
      this.rangeStart = moment(this.range.value.startRange).format('MMM DD YYYY')
      this.rangeEnd = moment(this.range.value.endRange).format('MMM DD YYYY')
     
      this.loadNotifications(this.rangeStart, this.rangeEnd); 
    }
  }

  async loadNotifications(startDate: string, endDate: string) {

    if (startDate == '' || endDate == '') {
      return false;
    }

    this.rangeStart = startDate;
    this.rangeEnd = endDate;

    this.totalMutedRange= 0;
    this.totalUnmutedRange =0;

    this.generatingChart = true;
    
    this.maxValue = 0;

    let periodValueHolder = [];
    this.periodLabel = [];
    this.periodTotalMuted = [];
    this.periodTotalUnmuted = [];

    let utcFormatStart = moment(startDate).utc(true).format();
    let utcFormatEnd = moment(endDate).utc(true).format();

    this.router.navigate(['/telegram/notification'],{queryParams:{start:moment(this.rangeStart).format('DD-MMM-YYYY'), end:moment(this.rangeEnd).format('DD-MMM-YYYY')}});

    this.telegramCollectionService.getAllNotifications(utcFormatStart, utcFormatEnd)
      .subscribe(async (response) => {
        
        let res;
        if(response){
          switch (this.selectedRange) {
            case 0:
              res = await GenerateNotificationDateList(new Date(this.rangeStart), new Date(this.rangeEnd), response.data);
              break;
            case 1:
              res = await GetWeeksInRange(new Date(this.rangeStart), new Date(this.rangeEnd), response.data)
              break;
            case 2:
              res = await GetMonthsInRange(new Date(this.rangeStart), new Date(this.rangeEnd), response.data)
              break;
          }
        }

        if(res){
          for (let data of res) {
            data.start = moment(data.start).format('DD MMM YYYY')
            this.periodLabel.push(data.label);
  
            periodValueHolder.push(data.muted);
            periodValueHolder.push(data.unmuted);
  
            this.periodTotalMuted.push(data.muted);
            this.periodTotalUnmuted.push(data.unmuted);
  
          }
          
            this.maxValue = Math.max(... periodValueHolder) > this.maxValue ? Math.max(... periodValueHolder) : this.maxValue ;
            this.lineChartOptions.scales.y.max = this.maxValue
            this.lineChartData.datasets[0].data = this.periodTotalMuted;
            this.lineChartData.datasets[1].data =  this.periodTotalUnmuted;         
            this.lineChartData.labels = this.periodLabel;
            this.chart?.chart.update();
          
          this.generatingChart = false;

        }

        this.tableSourceOfMutedNWorst = res;
        this.highestMuted = 0;
        this.highestUnmuted = 0;
        let bestMutedDays = await this.bestMutedDays(res);
      
        this.totalMutedDateRange = bestMutedDays.result;
       
        let worstMutedDays = await this.worstMutedDays(res);

        this.totalUnmutedDateRange = worstMutedDays.result;

        this.tableSourceOfMutedNWorst = this.tableSourceOfMutedNWorst.sort((a, b) => new Date(a.addedDate).getTime() - new Date(b.addedDate).getTime());

      
        for (let data of this.tableSourceOfMutedNWorst) {
          data.addedDate = moment(data.addedDate).format('DD MMM YYYY');
          data['net'] = data.muted - data.unmuted;
        
          if (data.muted > this.highestMuted) {
            this.highestMuted = data.muted;
          }
          
          if (data.unmuted > this.highestUnmuted) {
            this.highestUnmuted = data.unmuted;
          }

          this.totalMutedRange += data.muted;
          this.totalUnmutedRange += data.unmuted;

        }

        this.loadNotificationsTable(this.tableSourceOfMutedNWorst);    
      })
  }

  async loadNotificationsTable(tableData: any) {

    this.dataSource = new MatTableDataSource<NotificationsData>(tableData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  onStartRangeFromChange(event) {
    this.rangeStartFrom = moment(event.value).format('MMM DD YYYY')
    if (this.rangeStartFrom !== 'Invalid date') {
      this.loadComparisonFollowers(this.rangeStartFrom, this.rangeEndFrom, this.rangeStartTo, this.rangeEndTo);
    }
  }

  onEndRangeFromChange(event) {
    this.rangeEndFrom = moment(event.value).format('MMM DD YYYY')
    if (this.rangeEndFrom !== 'Invalid date') {
      this.loadComparisonFollowers(this.rangeStartFrom, this.rangeEndFrom, this.rangeStartTo, this.rangeEndTo);
    }
  }

  onStartRangeToChange(event) {
    this.rangeStartTo = moment(event.value).format('MMM DD YYYY')
    if (this.rangeStartTo !== 'Invalid date') {
      this.loadComparisonFollowers(this.rangeStartFrom, this.rangeEndFrom, this.rangeStartTo, this.rangeEndTo);
    }
  }

  onEndRangeToChange(event) {
    this.rangeEndTo = moment(event.value).format('MMM DD YYYY')
    if (this.rangeEndTo !== 'Invalid date') {
      this.loadComparisonFollowers(this.rangeStartFrom, this.rangeEndFrom, this.rangeStartTo, this.rangeEndTo);
    }
  }

  async loadComparisonFollowers(startDateFrom: string, endDateFrom: string, startDateTo: string, endDateTo: string) {
    if (startDateFrom == '' || endDateFrom == '' && startDateTo == '' || endDateTo == '') {
      return false;
    } 

    this.totalMutedFromRange = 0;
    this.totalUnmutedFromRange = 0;
    this.totalMutedToRange = 0;
    this.totalUnmutedToRange = 0;

    this.comparisonFrom = {
      start: moment(startDateFrom).utc(true).format(),
      end: moment(endDateFrom).utc(true).format()
    }

    this.comparisonTo = {
      start: moment(startDateTo).utc(true).format(),
      end: moment(endDateTo).utc(true).format()
    }
    
    this.telegramCollectionService.getNotificationsComparison(this.comparisonFrom,this.comparisonTo)
    .subscribe(async (res: any) => {

      for (let fromRange of res.from) {
        this.totalMutedFromRange += fromRange.muted
        this.totalUnmutedFromRange += fromRange.unmuted
      }

      for (let toRange of res.to) {
        this.totalMutedToRange += toRange.muted;
        this.totalUnmutedToRange += toRange.unmuted;
      }

      //FROM
      let bestMutedFromDays  = await this.bestMutedDays(res.from);
      this.totalMutedFromDateRange = bestMutedFromDays.result

      let worstMutedFromDays = await this.worstMutedDays(res.from);
      this.totalUnmutedFromDateRange = worstMutedFromDays.result
      
      // TO
      let bestMutedToDays  = await this.bestMutedDays(res.to);
      this.totalMutedToDateRange = bestMutedToDays.result
      
      let worstMutedToDays = await this.worstMutedDays(res.to);
      this.totalUnmutedToDateRange = worstMutedToDays.result
  
      this.mutedComparisonPercentage = (((this.totalMutedFromRange - this.totalMutedToRange) / this.totalMutedToRange) *100).toFixed(2);
      this.unmutedComparisonPercentage = (((this.totalUnmutedFromRange - this.totalUnmutedToRange) / this.totalUnmutedToRange)*100).toFixed(2);
      
      let netJoinFrom = this.totalMutedFromRange - this.totalUnmutedFromRange;
      let netJoinTo = this.totalMutedToRange - this.totalUnmutedToRange;
      
      this.netComparisonPercentage = (((netJoinFrom - netJoinTo)*100) / netJoinTo).toFixed(2);
    })

  }

  async bestMutedDays(data: INotification[]) {
    const sortedArray = data.sort((a, b) => b.muted - a.muted);
    const result: string[] = [];
    let totalResult = 0;
    for (let i = 0; i < 5 && i < sortedArray.length; i++) {
      sortedArray[i].addedDate = moment(sortedArray[i].addedDate).format('DD MMM YYYY');
      result.push(moment(sortedArray[i].addedDate).format('DD MMM YYYY'));
      totalResult = totalResult + sortedArray[i].muted;
    }

    return { 'result': result }
  }

  async worstMutedDays(data: INotification[]) {

    const sortedArray = data.sort((a, b) => b.unmuted - a.unmuted);
    let result: string[] = [];
    let totalResult = 0;
    for (let i = 0; i < 5 && i < sortedArray.length; i++) {
      sortedArray[i].addedDate = moment(sortedArray[i].addedDate).format('DD MMM YYYY');
      result.push(moment(sortedArray[i].addedDate).format('DD MMM YYYY'));
      totalResult = totalResult + sortedArray[i].unmuted;
    }

    return { 'result': result }
  }

  
  onChangeRange($event) {
    this.selectedRange = $event.value;
    this.loadNotifications(this.rangeStart, this.rangeEnd);
  }

  checkToDisplayRange() {
    return this.selected === 'QUARTER' || this.selected === 'LIFETIME' || this.selected === 'MONTH';
  }

  navigateByDate(date) {
    let endDate = moment(date).format('DD-MMM-YYYY')
    let startDate  = moment(endDate).subtract(2, 'days').format('DD-MMM-YYYY');
    this.router.navigate(['/telegram/post'],{queryParams:{start:startDate, end:endDate}});
  }

}
